import React from 'react';
import EzGrid, { EzColumn } from 'ez-data-grid';
import { Data } from './MockDataProvider';
 
function Example() {
    let settings = {
        maxHeight: "100%"
    }
 
    return (
        <EzGrid data={Data} settings={settings} onValueChange={(currentValue, parent, columnId, prevValue) => {
             // Handle the value change here.
        }}>
            <EzColumn key={"index"} title={"Id"} />
            <EzColumn key={"name"} title={"Name"} type={"text"} editable />
            <EzColumn key={"company"} title={"Company"} type={"text"} editable />
            <EzColumn key={"email"} title={"Email"} type={"text"} editable />
            <EzColumn key={"isActive"} title={"Active"} type={"checkbox"} editable />
        </EzGrid>);
}
 
export default Example;